<div class="app-body animated fadeIn m-0">
  <div class="row justify-content-center m-0 d-flex logo-row-center">
    <div class="col-lg-4 col-md-6 col-sm-9 col-12 login-new-details px-5 mt-0">
      <div class="logo-org mb-3">
        <img src="/assets/images/logo-high-white.png" />
      </div>
      <div class="login-form">
        <h4 class="sign-in-text">Sign In</h4>
        <form #loginForm="ngForm" (ngSubmit)="login()">
          <p class="mb-1" style="color: #f0fa00; text-align:center;">{{errorMsg}}</p>

          <div class="form-group mb-3">
            <input class="form-control" type="text" name="Lid" placeholder="Login Id" [(ngModel)]="model.loginId"
              required>
            <i class="fa fa-regular fa-user"></i>
            <p class="mb-1" style="color: #f0fa00; text-align:left">{{errorEmployeeid}}</p>
          </div>
          <div class="form-group mb-3">
            <input class="form-control" [type]="inputType" name="pw" placeholder="Password" [(ngModel)]="model.password"
              required>
            <i class="fa" [ngClass]="{'fa-eye': !showPassword, 'fa-eye-slash': showPassword}" aria-hidden="true"
              (click)="passwordVisibility()"></i>
            <p style="color: #f0fa00;text-align:left">{{errorPassword}}</p>
          </div>
          <!-- <div class="form-group mb-3">
                        <a href="javascript:void(0);" class="forgot-password" title="Forgot Password">Forgot Password</a>
                    </div> -->
          <div class="form-group mb-3">
            <button class="btn btn-login btn-block btn-shadow">Sign In</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>